import React, { useState } from 'react'
import { Spinner } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { useSessionContext } from '../contexts/SessionContext'
import { formatDateString } from '../utils/helpers/dates.helpers'
import { getUserGeoXpSpotCount } from '../utils/helpers/user-spot.helpers'
import { useMountEffect } from '../hooks/toolkit'
import RoleChip from './RoleChip'

const UserDataPanel: React.FC = () => {
  const { t } = useTranslation()
  const { user } = useSessionContext()
  const [uploadedSpotsCount, setUploadedSpotsCount] = useState<number | null>(null)
  const spotsLimit = user?.uploadLimit
  const spotsLimitLabel =
    spotsLimit === 'Infinity' || spotsLimit === Infinity ? t('userData.unlimited') : spotsLimit

  useMountEffect(() => {
    getUserGeoXpSpotCount()
      .then(({ count }) => setUploadedSpotsCount(count ?? null))
      .catch(() => {})
  })

  if (!user) {
    return <>{t('userData.userNotDefined')}</>
  }

  return (
    <div className="w-full mt-6">
      <div className="w-full flex flex-col justify-start items-start gap-2">
        <span data-testid="membership-user-name">
          <strong>{user.completeName}</strong>
        </span>

        <span className="inline-flex gap-2" data-testid="membership-member-since">
          {t('userData.memberSince')}: <strong>{formatDateString(user.confirmedAt)}</strong>
        </span>

        <span className="inline-flex gap-2" data-testid="membership-current-role">
          {t('userData.currentRole')}: <RoleChip role={user.role} testId="membership-role-chip" />
        </span>

        {user.subscription && (
          <>
            <span className="inline-flex gap-2" data-testid="membership-subscription-start">
              {t('userData.subscriptionStarted')}:{' '}
              <strong>{formatDateString(user.subscription.start_date)}</strong>
            </span>
            <span className="inline-flex gap-2" data-testid="membership-subscription-end">
              {t('userData.subscriptionExpires')}:{' '}
              {user.subscription.end_date ? (
                <strong>{formatDateString(user.subscription.end_date)}</strong>
              ) : (
                <strong>{t('userData.never')}</strong>
              )}
            </span>
          </>
        )}

        <span className="inline-flex gap-2" data-testid="membership-spots-uploaded">
          {t('userData.spotsUploaded')}:{' '}
          <strong>
            {uploadedSpotsCount ?? <Spinner className="inline-block h-3 w-3" />} / {spotsLimitLabel}
          </strong>
        </span>
      </div>
    </div>
  )
}

export default UserDataPanel
